// The status and mode vocabularies checkout stores and reports through its
// API. Plain tuples with no zod, because the checkout return page bundles
// this module for the browser; each consumer builds its own validator from
// them.

export const CHECKOUT_MODES = ["payment", "subscription"] as const;

export type CheckoutMode = (typeof CHECKOUT_MODES)[number];

export const CHECKOUT_SESSION_STATUSES = [
  "created",
  "paid",
  "expired",
  "abandoned",
] as const;

export type CheckoutSessionStatus = (typeof CHECKOUT_SESSION_STATUSES)[number];

export const CHECKOUT_SUBSCRIPTION_STATUSES = [
  "active",
  "past_due",
  "paused",
  "canceled",
  "incomplete",
] as const;

export type CheckoutSubscriptionStatus =
  (typeof CHECKOUT_SUBSCRIPTION_STATUSES)[number];
